// extracted by mini-css-extract-plugin
export default {"Store":"Store__Store___q1fct","heading":"Store__heading___esqBj","address":"Store__address___w5Zq5","type":"Store__type___Loe6x"};